<template>
  <PieChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    field-label="Eventos"
    class="make-a-copy"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import PieChart from '@/components/cards/models/PieChart';
import { mapActions } from 'vuex';
import cardsModel from '@/mixins/cards-model';
import highchartsBasics from '@/mixins/highcharts-basics';
import blipModel from '@/mixins/blip-model';
import EventBus from '@/utils/event-bus';

export default {
  name: 'BlipEventTrackPieChart',
  components: {
    PieChart,
  },
  mixins: [
    cardsModel,
    highchartsBasics,
    blipModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    isExpandedCard: {
      type: Boolean,
      default: false,
    },
    servicePath: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: [],
    };
  },
  computed: {
    series() {
      if (Boolean(this.rawSeries?.length)) {
        const seriesObject = this.rawSeries.reduce((seriesObject, { action, count }) => {
          if (!Boolean(seriesObject[action])) {
            seriesObject[action] = 0;
          }

          seriesObject[action] += Number(count);

          return seriesObject;
        }, {});

        return Object.keys(seriesObject)
          .map(name => ({
            name,
            y: seriesObject[name],
          }))
          .sort((actualValue, prevValue) => {
            if (actualValue.y < prevValue.y) return 0;
            return actualValue.y > prevValue.y ? -1 : 1;
          });
      }
      return [];
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getBlipService',
      'hasNoBlipBotAndContractFiltered',
      'getAppliedCardFilter',
    ]),
    async getData(options) {
      const appliedCardFilter = await this.getAppliedCardFilter(this.itemId);

      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      if (await this.hasNoBlipBotAndContractFiltered(this.itemId)) {
        this.requestStatus = 'emptyBot';
        return;
      }

      if (!this.isSingleBotSelected(appliedCardFilter)) {
        this.requestStatus = 'supportsOnlyOneBot';
        return;
      }

      this.getBlipService({
        servicePath: this.servicePath,
        itemId: this.itemId,
      })
        .then(response => {
          this.rawSeries = this.returnBlipSingleBotResponse(response).resource?.items;

          if (!Boolean(this.rawSeries?.length)) {
            this.requestStatus = 'error';
            return;
          }

          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = error.message;
        });
    },
  },
};
</script>
